const NotFound = () => {
  return (
    <div>
      <h1>404 Page Error</h1>
    </div>
  )
}

export default NotFound
